const Event = require('../../../entities/Event');
const { Age } = require('../../../Constants/Constants');
const EventNames = require('../../Names/EventNames');

class ImpactOfScience extends Event {
    constructor(){
        super(
            Age.Age3,
            EventNames.ImpactOfScience,
            "Each civilizations score culture according to the relative amount of science it produces:/n" + 
            "4 players: 15/10/5/0 culture;\n" + 
            "3 players: 14/7/0 culture;\n" + 
            "2 players: 10/0 culture;\n" + 
            "(In case of ties see the rules)",
            {}
        )
    }
}

module.exports = ImpactOfScience;